angular.module('am4').directive('checkPermissionForElement', function($rootScope) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let permissions = JSON.parse('[' + attrs.checkPermissionForElement + ']'),
                userPermissions,
                shouldHideElement = false;

            userPermissions = $rootScope.userPermissions;
            permissions.forEach(function(permission) {
                let permissionArray = [].concat(permission);
                shouldHideElement = (!permissionArray.every((permission) => userPermissions.includes(permission)));
            });

            if (shouldHideElement) {
                element.hide();
            }
        }
    };
});




// WEBPACK FOOTER //
// ./src/app/directives/checkPermissionForElement.js